export default __webpack_public_path__ + "static/media/step3.29471cf1.png";